export default __webpack_public_path__ + "static/feature-1-bcb0dbddb90baf4a983262e29602a5bc.svg";